var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"--call"},[_vm._v(" -- Call Message -- ")])
}
var staticRenderFns = []

export { render, staticRenderFns }